<div class="modal fade previewWhitepaperPopup" style="display: block;">
    <div class="modal-dialog" role="document">
        <div class="modal-content" style="margin-top: 8% !important">
            <div class="modal-header">
                <div class="row">
                    <div class="col-11">
                        <h1 class="modal-title">Vote</h1>
                    </div>
                    <div class="col-1">
                        <button mat-icon-button style="float: right" (click)="onClickClose()">
                            <span class="icon-close" style="float: right"> </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="modal-body" style="text-align: initial">
                <iframe [src]="safeUrl" width="100%" height="100%" frameborder="0"
                    style="border:none; display:block;"></iframe>
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>